/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const additionalSubmissionQuestionDataQuestionAttributeSchema = z.enum([
	'name',
	'email',
	'phone',
	'contact_consent',
	'cv',
])

export type AdditionalSubmissionQuestionDataQuestionAttributeSchema = z.infer<
	typeof additionalSubmissionQuestionDataQuestionAttributeSchema
>
